import { Button, Card, Col, Flex, List, Modal, Row, notification } from "antd";
import React, { useState } from "react";
import {
  GreenhouseIcon,
  GreenhouseWhiteIcon,
  LeverIconCompo,
  SmartRecruiterIcon,
  SmartRecruiterWhiteIcon,
} from "../../../Icon/Icon";
import { CloseCircleOutlined, CheckCircleTwoTone } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { sendCandidates } from "api/smart.api";
import TagList from "./TagList";
import ProjectList from "./ProjectList";
import ExpandableButton from "components/Common/Button/ExpandableButton";
import { trimStr } from "utils";
import CustomTagWithPlus from "components/Common/Tag/CustomTagWithPlus";
import { SvgIcons } from "Icon/SvgIcons";

interface Props {
  selectedCandidateList: any[];
  roleId: any;
  title?: string;
  allIdsSelected?: any;
  isExpanded?: boolean;
}
export const SmartRecruiter: React.FC<Props> = ({
  title,
  selectedCandidateList,
  roleId,
  allIdsSelected,
  isExpanded,
}) => {
  const { t } = useTranslation();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [selectedProject, setSelectedProject] = useState<any | null>(null);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const hideModal = () => {
    setIsModalOpen(false);
  };
  const openNotification = (responseData: any) => {
    notification.open({
      message: title ? title : "Smart Recruiter",
      description: (
        <List
          itemLayout="horizontal"
          dataSource={responseData ? responseData : []}
          renderItem={(item: any, index) => (
            <List.Item>
              <List.Item.Meta
                title={item.candidate_name}
                avatar={
                  item.reason ? (
                    <CloseCircleOutlined twoToneColor="#FF0000" size={25} />
                  ) : (
                    <CheckCircleTwoTone twoToneColor="#52C41A" size={25} />
                  )
                }
                description={
                  item.reason
                    ? item.reason
                    : t("candidate") + ` sent successfully to ${title ? title : "Smart Recruiter"} `
                }
              />
            </List.Item>
          )}
        />
      ),
    });
  };
  const openNotificationError = () => {
    notification.error({
      message: title ? title : "Smart Recruiter",
      description: `Something went wrong when sending candidate to ${
        title ? title : "Smart Recruiter"
      }`,
    });
  };
  const handleSendToSmartRecruiter = async () => {
    if (selectedProject && selectedTags.length > 0) {
      setConfirmLoading(true);
      try {
        const data = await sendCandidates({
          candidates: selectedCandidateList,
          tags: selectedTags,
          job_id: selectedProject.job_id,
          project_id: roleId,
          select_all: allIdsSelected,
        });
        openNotification(data);
        setConfirmLoading(false);
        hideModal();
      } catch (error) {
        setConfirmLoading(false);
        openNotificationError();
      }
      setConfirmLoading(false);
      hideModal();
    } else {
      // Handle case where project and tags are not selected
      console.error("Please select a project and at least one tag.");
    }
  };
  const handleCheckboxChange = (tagName: string) => {
    if (selectedTags?.includes(tagName.toString())) {
      // If the tag is already selected, remove it from the selectedTags array
      setSelectedTags((prevSelectedTags) =>
        prevSelectedTags.filter((name) => name !== tagName.toString())
      );
      // onSelect(selectedTags.filter((name) => name !== tagName.toString()));
    } else {
      // If the tag is not selected, add it to the selectedTags array
      setSelectedTags((prevSelectedTags) => [...prevSelectedTags, tagName.toString()]);
      // onSelect([...selectedTags, tagName.toString()]);
    }
  };
  return (
    <>
      <ExpandableButton
        isExpanded={isExpanded}
        icon={
          title === "Greenhouse" ? (
            <GreenhouseWhiteIcon size={20} />
          ) : title === "Lever" ? (
            <LeverIconCompo size={20} />
          ) : (
            <SmartRecruiterWhiteIcon size={20} />
          )
        }
        // loading={loadingReject}
        text={title ? title : "Smart Recruiter"}
        onClick={() => {
          showModal();
        }}
        disabled={selectedCandidateList.length === 0}
      />
      {/* <Button
        type="link"
        disabled={selectedCandidateList.length === 0}
        style={{
          display: "flex",
          cursor:
            selectedCandidateList.length === 0 ? "not-allowed" : "pointer",
        }}
        onClick={() => {
          showModal();
        }}
        icon={title ? <GreenhouseIcon /> : <SmartRecruiterIcon />}
        className="gray-gray-9"
      >
        {title ? title : "Smart Recruiter"}
      </Button> */}
      <Modal
        className="add-candidate-model"
        title={
          <Flex gap={20} className="pb-5">
            {SvgIcons.featuredCheckIcon}
            <Flex vertical>
              <span className="text-lg text-fonttext-primary font-semibold">
                Move Candidate(s) to {title ? title : "Smart Recruiter"} ATS
              </span>
              <span className="text-sm text-text-tertiary font-normal">
                Select the job and tags before sending candidates to the{" "}
                {title ? title : "Smart Recruiter"} ATS.
              </span>
            </Flex>
          </Flex>
        }
        footer={null}
        // title="Export Profile"
        visible={isModalOpen}
        onCancel={hideModal}
        style={{ top: 20 }}
      >
        <Card
          id="smart-req-card"
          style={{
            boxShadow: "none",
          }}
          bordered={false}
          bodyStyle={{ padding: 0 }}
        >
          <Row gutter={24}>
            <Col span={12} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }}>
              <Card
                title={false}
                bordered={false}
                style={{
                  boxShadow: "none",
                  padding: 0,
                }}
                bodyStyle={{ padding: "0", maxHeight: "auto" }}
              >
                <span className="text-lg text-fonttext-primary font-semibold">Select Job</span>
                <ProjectList
                  onSelect={(project: string) => setSelectedProject(project)}
                  selectedProject={selectedProject}
                />
              </Card>
            </Col>
            <Col
              span={12}
              md={{ span: 24 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}
              className="addToRole"
            >
              <Card
                title={false}
                bordered={false}
                style={{
                  boxShadow: "none",
                }}
                bodyStyle={{ padding: "0", maxHeight: "auto !important" }}
              >
                <span className="text-lg text-fonttext-primary font-semibold">Select Tags</span>
                <TagList
                  onSelect={(tags: string) => handleCheckboxChange(tags)}
                  selectedTags={selectedTags}
                />
              </Card>
            </Col>
          </Row>
          {/* {selectedProject?.name ? (
            <div className="py-3">
              <div className="field-title-model mb-1">Your Tags</div>
              <Flex className="flex-wrap" gap={4} align="center" style={{ maxHeight: "200px", overflow: "auto" }}>
                {selectedProject?.name ? (
                  <CustomTagWithPlus
                    key={selectedProject.job_id}
                    value={trimStr(selectedProject.name, 25)}
                    isSelected={true}
                    hideIcon={true}
                  />
                ) : (
                  ""
                )}
              </Flex>
            </div>
          ) : (
            ""
          )}
          {selectedTags && selectedTags.length ? (
            <div className="pb-3">
              <div className="field-title-model mb-1">Your Tags</div>
              <Flex className="flex-wrap" gap={4} align="center" style={{ maxHeight: "150px", overflow: "auto" }}>
                {selectedTags.map((title: any) => {
                  return (
                    <CustomTagWithPlus
                      value={trimStr(title)}
                      isSelected={true}
                      key={title}
                      handleClick={() => {
                        handleCheckboxChange(title);
                      }}
                    />
                  );
                })}
              </Flex>
            </div>
          ) : (
            ""
          )} */}
        </Card>
        <Row align="middle" className="pt-8">
          <Button className="m-1 flex-grow" loading={confirmLoading} onClick={hideModal}>
            Cancel
          </Button>
          <Button
            type="primary"
            className="m-1 flex-grow"
            disabled={!selectedTags.length || !selectedProject}
            loading={confirmLoading}
            onClick={handleSendToSmartRecruiter}
          >
            Send To {title ? title : "Smart Recruiter"}
          </Button>
        </Row>
      </Modal>
    </>
  );
};
